import React, { useState, useEffect } from 'react';

const Counter = ({ initialValue, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = null;
    const step = timestamp => {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const increment = Math.ceil((initialValue * progress) / duration);
      if (increment < initialValue) {
        setCount(increment);
        requestAnimationFrame(step);
      } else {
        setCount(initialValue);
      }
    };
    requestAnimationFrame(step);

    return () => cancelAnimationFrame(step);
  }, [initialValue, duration]);

  return (
    <div className="text-3xl font-bold text-center text-gray-800">
      {count}
    </div>
  );
};

export default Counter;
